import { DisplayCurrencyProvider } from "./contexts/DisplayCurrencyContext"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import "./styles/index.css"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { store } from "./store/store"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <DisplayCurrencyProvider><App /></DisplayCurrencyProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)
